<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-container *ngIf="labelModel" [kitComponent]="labelModel"
  kitComponentClass="kit-form-field-label col col-form-label"></ng-container>
<div class="col col-form-control">
  <ng-container [kitComponent]="model.control" kitComponentClass="kit-form-field-control">
  </ng-container>
  <div [kitValueError]="model.control" class="invalid-feedback"></div>
</div>